import { IScopeBoundController } from "../../../angular-core";

const bindings = {
    resolve: "<",
    close: "&",
    dismiss: "&"
};

class MarketCloneComponentController implements IScopeBoundController<typeof bindings> {
    static $inject = ["$scope"];

    marketName: string;
    marketVersion: string;
    type: string;
    budgetYear: number;
    saveAsNew: Record<string, string | boolean>;

    resolve: { name: string; version: string; type: string; budgetYear: number };
    close: (x: { $value: { name: string; version: string; budgetYear: number } }) => void;
    dismiss: (x: { $value: string }) => void;

    $onInit() {
        this.marketName = this.resolve.name;
        this.marketVersion = this.resolve.version;
        this.type = this.resolve.type;
        this.budgetYear = this.resolve.budgetYear;
    }
    
    ok() {
        if (this.saveAsNew.$invalid) {
            this.saveAsNew.$submitted = true;
        } else {
            this.close({
                $value: { name: this.marketName, version: this.marketVersion, budgetYear: this.budgetYear }
            });
        }
    }

    cancel() {
        this.dismiss({ $value: "cancel" });
    }
}

export class MarketCloneComponent implements ng.IComponentOptions {
    static componentName = "marketClone";
    bindings = bindings;
    controller = MarketCloneComponentController;
    template = require("./marketCloneComponent.html");
}

angular
    .module("topline.modules")
    .component(MarketCloneComponent.componentName, new MarketCloneComponent());
